import { motion } from "framer-motion";
import { useMemo } from "react";

/**
 * Fireworks — 3 timed radial bursts at random positions across the screen.
 * Each burst = 22 rays radiating from a center point, staggered.
 */
export default function Fireworks({ burstCount = 3 }) {
  const bursts = useMemo(
    () =>
      Array.from({ length: burstCount }, (_, i) => ({
        i,
        left: 15 + Math.random() * 70,
        top: 20 + Math.random() * 45,
        delay: i * 0.5,
        color: ["#fbbf24", "#a78bfa", "#22d3ee"][i % 3],
      })),
    [burstCount],
  );

  return (
    <div
      aria-hidden
      className="absolute inset-0 pointer-events-none overflow-hidden"
    >
      {bursts.map((b) => (
        <Burst key={b.i} {...b} />
      ))}
    </div>
  );
}

function Burst({ left, top, delay, color }) {
  const rays = 22;
  return (
    <div className="absolute" style={{ left: `${left}%`, top: `${top}%` }}>
      {Array.from({ length: rays }).map((_, i) => {
        const angle = (i / rays) * 360;
        const dist = 90 + Math.random() * 60;
        const rad = (angle * Math.PI) / 180;
        const x = Math.cos(rad) * dist;
        const y = Math.sin(rad) * dist;
        return (
          <motion.span
            key={i}
            initial={{ x: 0, y: 0, opacity: 1, scale: 0.6 }}
            animate={{
              x,
              y: y + 60,
              opacity: [1, 1, 0],
              scale: 1,
            }}
            transition={{ duration: 1.4, delay, ease: "easeOut" }}
            className="absolute rounded-full"
            style={{
              width: 4,
              height: 4,
              background: color,
              boxShadow: `0 0 12px ${color}, 0 0 24px ${color}`,
            }}
          />
        );
      })}
      {/* Flash core */}
      <motion.span
        initial={{ scale: 0, opacity: 1 }}
        animate={{ scale: 2, opacity: 0 }}
        transition={{ duration: 0.6, delay, ease: "easeOut" }}
        className="absolute rounded-full"
        style={{
          width: 40,
          height: 40,
          background: `radial-gradient(circle, ${color} 0%, transparent 70%)`,
          filter: "blur(4px)",
          transform: "translate(-50%, -50%)",
        }}
      />
    </div>
  );
}
